import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "content", "input"]
  static values = {
    panelHeight: { type: Number, default: 150 }
  }

  connect() {
    const p1 = this.element.querySelector('#p1')
    const p2 = this.element.querySelector('#p2')

    this._searchShape = {
      s1: "M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z",
      s2: "M21 21L16.65 16.65"
    }
    this._closeShape = {
      s1: "M18.5 5.5L5.5 18.5",
      s2: "M5.5 5.5L18.5 18.5"
    }

    // Use fallback panel/content/input if targets not provided
    if (!this.hasPanelTarget) {
      this._panel = document.getElementById(this.element.getAttribute('aria-controls')) || document.getElementById('searchBox')
    }
    if (!this.hasInputTarget) {
      this._input = this._panel?.querySelector('input')
    }

    // Click handler
    this.element.addEventListener('click', (e) => {
      // Close mobile menu first if open
      const openMobile = document.querySelector('.mobile-nav-button[aria-expanded="true"]')
      if (openMobile) {
        openMobile.click()
        setTimeout(() => this._toggle(), 180)
        return
      }
      this._toggle()
    })

    // ESC to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this._isOpen()) this._close()
    })

    // External close request
    document.addEventListener('search:close', () => {
      if (this._isOpen()) this._close()
    })
  }

  _isOpen() {
    return this.element.getAttribute('aria-expanded') === 'true'
  }

  _toggle() {
    this._isOpen() ? this._close() : this._open()
  }

  _open() {
    const el = this.element
    const panel = this.hasPanelTarget ? this.panelTarget : this._panel
    const content = this.hasContentTarget ? this.contentTarget : panel?.querySelector('.search-content') || panel
    const input = this.hasInputTarget ? this.inputTarget : this._input

    el.setAttribute('aria-expanded', 'true')
    panel.setAttribute('aria-hidden', 'false')

    // GSAP animations
    if (window.gsap) {
      const p1 = el.querySelector('#p1')
      const p2 = el.querySelector('#p2')
      gsap.to(p1, { attr: { d: this._closeShape.s1 }, duration: 0.4, ease: 'back.out(1.7)' })
      gsap.to(p2, { attr: { d: this._closeShape.s2 }, duration: 0.4, ease: 'back.out(1.7)' })
      gsap.to(panel, { height: this.panelHeightValue, duration: 0.5, ease: 'power3.out' })
      gsap.to(content, { opacity: 1, y: 0, duration: 0.4, delay: 0.1 })
    }

    setTimeout(() => input?.focus(), 300)
  }

  _close() {
    const el = this.element
    const panel = this.hasPanelTarget ? this.panelTarget : this._panel
    const content = this.hasContentTarget ? this.contentTarget : panel?.querySelector('.search-content') || panel

    el.setAttribute('aria-expanded', 'false')
    panel.setAttribute('aria-hidden', 'true')

    if (window.gsap) {
      const p1 = el.querySelector('#p1')
      const p2 = el.querySelector('#p2')
      gsap.to(p1, { attr: { d: this._searchShape.s1 }, duration: 0.4, ease: 'power2.inOut' })
      gsap.to(p2, { attr: { d: this._searchShape.s2 }, duration: 0.4, ease: 'power2.inOut' })
      gsap.to(panel, { height: 0, duration: 0.4, ease: 'power3.inOut' })
      gsap.to(content, { opacity: 0, y: 20, duration: 0.2 })
    }
  }
}
